import React, { useState, useEffect } from "react";
import axios from "axios";
import Skeleton from "react-loading-skeleton";

import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import styled from "styled-components";

export const Wrapper = styled.section`
  font-size: 15px;
  strong {
    display: inline-block;
    font-size: 17px;
    background-color: #e2e2e2;
    padding: 1px 9px;
    margin-bottom: 8px;
  }
  a {
    color: #66c;
  }
`;

// //www.dreamchimney.com/api/tracks/message-board/promotracks/mostrecent
// //www.dreamchimney.com/api/tracks/message-board/banner/motw

const FeaturedPromoMixes = (props) => {
  const [data, setData] = useState({ motw: {}, promo: {} });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      // You can await here
      const promo = await axios("//www.dreamchimney.com/api/tracks/message-board/promotracks/mostrecent");
      const motw = await axios("//www.dreamchimney.com/api/tracks/message-board/banner/motw");
      // ...
      setData({ promo: promo.data[0] ? promo.data[0] : {}, motw: motw.data });
      setLoading(false);
    }
    fetchData();
  }, []);

  return (
    <div className="totd-featured-box">
      <Row>
        <Col xs={12} sm={4} className="featured-header">
          <h2 className="page-header">
            <FontAwesomeIcon icon="headphones-alt" className="headphones-alt" />
            Weekly Features
          </h2>
        </Col>
        <Col xs={6} sm={4} className="">
          <Wrapper>
            <strong>DC Promo Tracks #{data.promo.id}</strong>
          </Wrapper>
          <Wrapper>
            {loading && <Skeleton count="2" />}
            {!loading && (
              <div>
                {data.promo.artist} "
                <a href={`//www.dreamchimney.com/promo/${data.promo.slug}`} target="_blank">
                  {data.promo.title}
                </a>
                " on {data.promo.label}
              </div>
            )}
          </Wrapper>
        </Col>
        <Col xs={6} sm={4} className="">
          <Wrapper>
            <strong>Mix of the Week</strong>
          </Wrapper>
          <Wrapper>
            {loading && <Skeleton count="2" />}
            {!loading && (
              <div>
                {data.motw.title.toLowerCase() === "mix for dream chimney" ? (
                  <span>
                    <a href={data.motw.url} target="_blank" rel="noopener noreferrer">
                      Mix #{data.motw["motw-series-number"]}
                    </a>
                  </span>
                ) : (
                  <span>
                    Mix #{data.motw["motw-series-number"]} "
                    <a href={data.motw.url} target="_blank" rel="noopener noreferrer">
                      {data.motw.title}
                    </a>
                    "
                  </span>
                )}{" "}
                by {data.motw.dj}
              </div>
            )}
          </Wrapper>
        </Col>
      </Row>
    </div>
  );
};

export default FeaturedPromoMixes;
